module.exports = (Promise.resolve(__parcel__require__("./" + "Debugger.worker.ab29d8a7.d0a30020.06c63ca0.js"))).then(() => parcelRequire('2jPqd'));